/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import PropsPanel from 'loracoms/PropsPanel';
import PageLoading from 'loracoms/PageLoading';
import PageError from 'loracoms/PageError';
import accountActions from 'loraactions/account';
import orgActions from 'loraactions/org';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  allSuccess,
  someFailure,
  somePending,
  findFailure,
} from 'lorautils/api/status';
import config from 'loracfg';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  orgBasic: React.PropTypes.object.isRequired,
  accountBasic: React.PropTypes.object.isRequired,
  accountUpdated: React.PropTypes.object.isRequired,
  updateAccount: React.PropTypes.func.isRequired,
  updateOrg: React.PropTypes.func.isRequired,
  orgUpdated: React.PropTypes.object.isRequired,
  getAccountBasic: React.PropTypes.func.isRequired,
  getOrgBasic: React.PropTypes.func.isRequired,
  plan: React.PropTypes.object.isRequired,
};

class InfoView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
      orgBasic: props.orgBasic,
      accountBasic: props.accountBasic,
      accountUpdated: props.accountUpdated,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'accountcenter.infoview');
  }

  componentWillMount() {
    const { getAccountBasic } = this.props;
    getAccountBasic();
  }

  componentWillReceiveProps(nextProps) {
    const {
      orgBasic,
      accountBasic,
      accountUpdated,
      plan,
      orgUpdated,
      getOrgBasic,
      getAccountBasic,
    } = nextProps;

    if (orgBasic !== this.props.orgBasic) {
      this.setState({ orgBasic });
    }
    if (accountBasic !== this.props.accountBasic) {
      this.setState({ accountBasic });
    }
    if (orgUpdated !== this.props.orgUpdated) {
      if (orgUpdated.status === 'success') {
        getOrgBasic();
      }
    }
    if (accountUpdated !== this.props.accountUpdated) {
      if (accountUpdated.status === 'success') {
        getAccountBasic();
      }
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  handleSubmit(data, dirtyIds) {
    if (dirtyIds.length === 0) {
      return true;
    }

    const { updateAccount, updateOrg } = this.props;
    const { company, ...accountData } = data;

    if (dirtyIds.includes('company')) {
      updateOrg({ company });
    }
    if (!dirtyIds.includes('company') || dirtyIds.length > 2) {
      updateAccount(accountData);
    }

    return true;
  }

  renderBasic() {
    const { accountBasic, orgBasic, editBasic = false } = this.state;
    const {
      data: {
        name,
        tel,
        email,
      } = {},
    } = accountBasic;
    const {
      data: {
        company,
      },
    } = orgBasic;

    const data = {
      name,
      tel,
      email,
      company,
      login: email,
    };

    const properties = [{
      id: 'login',
      name: this.intlMsg.msg('basic.login'),
      readOnly: true,
    }, {
      id: 'name',
      name: this.intlMsg.msg('basic.name'),
    }, {
      id: 'tel',
      name: this.intlMsg.msg('basic.telephone'),
    }, {
      id: 'email',
      name: this.intlMsg.msg('basic.email'),
      readOnly: true,
    }, {
      id: 'company',
      name: this.intlMsg.msg('basic.company'),
    }];

    return (
      <PropsPanel
        title={this.intlMsg.msg('basic.title')}
        properties={properties}
        data={data}
        onSubmit={this.handleSubmit}
        edit={editBasic}
        show={{
          display: {
            email: config.profile === 'cloud',
          },
          edit: {
            email: config.profile === 'cloud',
          },
        }}
      />
    );
  }

  renderQuota() {
    const { orgBasic: { data: orgBasic } } = this.state;
    const {
      lrappnum,
      lrgatewaynum,
      lrnodenum,
    } = orgBasic;
    const data = {
      lrappnum,
      lrgatewaynum,
      lrnodenum,
    };

    const properties = [{
      id: 'lrappnum',
      name: this.intlMsg.msg('quota.lrappnum'),
      readOnly: true,
    }, {
      id: 'lrgatewaynum',
      name: this.intlMsg.msg('quota.lrgatewaynum'),
      readOnly: true,
    }, {
      id: 'lrnodenum',
      name: this.intlMsg.msg('quota.lrnodenum'),
      readOnly: true,
    }];

    return (
      <PropsPanel
        readOnly
        title={this.intlMsg.msg('quota.title')}
        properties={properties}
        data={data}
      />
    );
  }

  renderBilling() {
    const { pushState } = this.props;
    const { plan } = this.state;
    const {
      data: {
        balance,
        billday,
        tier,
      },
    } = plan;

    const data = {
      balance,
      billday,
      tier,
    };
    const properties = [{
      id: 'tier',
      name: this.intlMsg.msg('plan.tier'),
      formatter: (x) => {
        if (x === 1) {
          return (
            <span>
              {this.intlMsg.msg('plan.trialuser')}
              <Button
                bsStyle="aisz-link-warning"
                className={styles.action}
                onClick={() => pushState('/billing/plans')}
              >
                {this.intlMsg.msg('plan.upgrade')}
              </Button>
            </span>
          );
        } else if (x === 2) {
          return (
            <span>
              {this.intlMsg.msg('plan.svcpackuser')}
              <Button
                bsStyle="aisz-link-warning"
                className={styles.action}
                onClick={() => pushState('/billing/plans')}
              >
                {this.intlMsg.msg('plan.upgrade')}
              </Button>
            </span>
          );
        } else if (x === 3) {
          return <span>{this.intlMsg.msg('plan.commuser')}</span>;
        }
        return <i className="fa fa-question" />;
      },
    }, {
      id: 'balance',
      name: this.intlMsg.msg('plan.balance'),
      formatter: x => (
        <span>
          {x} {this.intlMsg.msg('plan.rmbyuan')}
          <Button
            bsStyle="aisz-link"
            className={styles.action}
            onClick={() => pushState('/billing/recharge')}
          >
            {this.intlMsg.msg('plan.recharge')}
          </Button>
        </span>
      ),
    }, {
      id: 'billday',
      name: this.intlMsg.msg('plan.billday'),
    }];

    return (
      <PropsPanel
        readOnly
        title={this.intlMsg.msg('plan.title')}
        properties={properties}
        data={data}
        show={{ billday: billday > 0 }}
      />
    );
  }

  renderContent() {
    return (
      <div className={styles.content}>
        <ul className={styles.propslist}>
          <li> {this.renderBasic()} </li>
          <li> {this.renderQuota()} </li>
          <ShowIf if={config.profile === 'cloud'}>
            <li> {this.renderBilling()} </li>
          </ShowIf>
        </ul>
      </div>
    );
  }

  render() {
    const {
      accountBasic,
      orgBasic,
      plan,
    } = this.state;

    if (somePending(accountBasic, orgBasic, plan)) {
      return <PageLoading />;
    }

    if (someFailure(accountBasic, orgBasic, plan)) {
      const failure = findFailure(accountBasic, orgBasic, plan);
      return <PageError title={this.intlMsg.errorMsg(failure.error.code)} />;
    }

    if (allSuccess(accountBasic, orgBasic, plan)) {
      return this.renderContent();
    }

    return null;
  }
}

InfoView.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
  orgBasic: state.org.basic,
  accountBasic: state.account.basic,
  accountUpdated: state.account.updateBasic,
  orgUpdated: state.org.updateBasic,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getAccountBasic: accountActions.basic,
  updateAccount: accountActions.updateBasic,
  updateOrg: orgActions.updateBasic,
  getOrgBasic: orgActions.basic,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(InfoView, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/AccountCenter/coms/InfoView/index.jsx